var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("MatchMedia", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ desktop }) {
          return [
            _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.groupList,
                      "row-class-name": "cursor-pointer",
                    },
                    on: {
                      "row-click": _vm.onRowClick,
                      "cell-mouse-leave": _vm.onCellMouseLeave,
                      "cell-mouse-enter": _vm.onCellMouseEnter,
                    },
                  },
                  [
                    desktop
                      ? _c("el-table-column", {
                          attrs: { prop: "name", label: "NOMBRE" },
                        })
                      : _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: "NOMBRE",
                            width: "100",
                          },
                        }),
                    _c("el-table-column", {
                      attrs: { prop: "description", label: "DESCRIPCION" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }